var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2510",
    "data-name": "Rectangle 2510",
    width: 35.195,
    height: 46.901,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609",
    transform: "translate(-436 -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(435.588 407.449)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 47,
    cy: 47.5,
    rx: 47,
    ry: 47.5,
    transform: "translate(0.412 -0.449)",
    fill: "#fff",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608",
    transform: "translate(465 431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608-2",
    "data-name": "Group 6608",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25643",
    "data-name": "Path 25643",
    d: "M4.408,19c0-.185,0-.375,0-.566.011-2.011-.05-4.025.049-6.031a13.175,13.175,0,0,1,26.155-1.353,17.159,17.159,0,0,1,.172,2.47c.026,1.654.008,3.308.008,4.962v.487a14.3,14.3,0,0,1,1.606.382A4.289,4.289,0,0,1,35.19,23.61c.01,2.189,0,4.378,0,6.567q0,6.057,0,12.113A4.223,4.223,0,0,1,32.7,46.453a4.731,4.731,0,0,1-1.921.427q-13.183.041-26.366.013a4.309,4.309,0,0,1-4.406-4.5c-.018-2.562,0-5.124,0-7.686,0-3.7-.007-7.394,0-11.091a4.3,4.3,0,0,1,3.161-4.38c.371-.1.761-.142,1.238-.228M17.6,21.986H4.756c-1.351,0-1.816.459-1.816,1.806q0,9.194,0,18.388c0,1.309.486,1.79,1.793,1.79H30.466c1.307,0,1.793-.482,1.793-1.79q0-9.218,0-18.436c0-1.283-.483-1.757-1.77-1.757H17.6m10.238-2.952c0-2.147.059-4.239-.011-6.328a10.243,10.243,0,0,0-20.474.537c-.017,1.768,0,3.535,0,5.3,0,.156.018.312.029.488Z",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25644",
    "data-name": "Path 25644",
    d: "M104.422,213.138a1.781,1.781,0,0,1,0-.243,1.812,1.812,0,0,0-1.056-2.128,4.165,4.165,0,0,1-1.569-5.18,4.349,4.349,0,0,1,4.635-2.7,4.3,4.3,0,0,1,3.812,3.765,4.344,4.344,0,0,1-2.609,4.6.618.618,0,0,0-.276.459c-.026.923-.007,1.848-.015,2.772a1.463,1.463,0,1,1-2.922.017c-.006-.454,0-.908,0-1.362m1.434-4.441a1.372,1.372,0,0,0,1.489-1.424,1.46,1.46,0,1,0-2.919-.058,1.371,1.371,0,0,0,1.431,1.482",
    transform: "translate(-88.286 -176.47)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.06c876393391238e1f3b9e55db3cb26b.svg";
export { ForwardRef as ReactComponent };